import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import "../styles/pricing.scss";
import Nav from "./Nav";
import Footer from "./Footer";
import PageMeta from "./PageMeta";
import StoreCta from "./StoreCta";
import { FadeInUp, StaggerChildren, StaggerItem } from "./motion";
import {
  pricingHero,
  pricingTiers,
  pricingNote,
  pricingMeta,
} from "../content/pricing";
import {
  organizationSchema,
  buildBreadcrumbSchema,
  innerPageBreadcrumbs,
} from "../content/seo";

const Pricing = () => {
  const breadcrumbSchema = buildBreadcrumbSchema(innerPageBreadcrumbs.pricing);

  return (
    <main className="pricing">
      <PageMeta
        meta={pricingMeta}
        jsonLd={[organizationSchema, breadcrumbSchema]}
      />
      <Nav page="pricing" />
      <FadeInUp as="header" className="page-hero">
        <h1>{pricingHero.title}</h1>
        <p>{pricingHero.subtitle}</p>
      </FadeInUp>
      <section className="content-section">
        <StaggerChildren className="pricing-cards">
          {pricingTiers.map((tier) => (
            <StaggerItem key={tier.name} className="info-card pricing-card">
              <h2>{tier.name}</h2>
              <p className="price">{tier.price}</p>
              {tier.duration && <p className="duration">{tier.duration}</p>}
              <p>{tier.description}</p>
              <ul className="pricing-card__includes">
                {tier.includes.map((item) => (
                  <li key={item}>
                    <CheckCircleOutlineIcon fontSize="small" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
            </StaggerItem>
          ))}
        </StaggerChildren>
        <FadeInUp>
          <p className="content-note">{pricingNote}</p>
        </FadeInUp>
        <FadeInUp>
          <StoreCta className="content-cta" />
        </FadeInUp>
      </section>
      <Footer />
    </main>
  );
};

export default Pricing;
